export const NAV = [
	{ label: 'Αρχική', hash: 'arxiki' },
	{ label: 'Λύσεις', hash: 'lyseis' },
	{ label: 'Για καταστήματα', hash: 'katastimata' },
	{ label: 'Για διανομείς', hash: 'dianomeis' },
	{ label: 'Για στόλους', hash: 'stoloi' },
	{ label: 'Περιοχές', to: '/perioxes' },
	{ label: 'Integrations', hash: 'integrations' },
	{ label: 'Επικοινωνία', hash: 'epikoinonia' },
];

// On the home page a nav item scrolls to its section; from any other public
// page it goes to the home page at that section.
export const navHref = (item, onHome) => item.to || (onHome ? `#${item.hash}` : `/#${item.hash}`);
